import _toConsumableArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React, { useState } from 'react';
import useSWR from 'swr';
import { useOauth } from '@peloton/auth';
import { isDefined } from '@peloton/types';
import { ok, pending } from '@engage/result';
import { AuthFetchers } from '@webtv/data-fetch';
import useOauthEnabled from './useOauthEnabled';

var useIsLoggedIn = function useIsLoggedIn() {
  var _useState = useState(false),
      hasCompletedAuthCheck = _useState[0],
      setHasCompletedAuthCheck = _useState[1];

  var _useState2 = useState(false),
      hasPendingAuthCheck = _useState2[0],
      setHasPendingAuthCheck = _useState2[1];

  var _useState3 = useState(undefined),
      isAuthenticated = _useState3[0],
      setIsAuthenticated = _useState3[1];

  var oauthEnabled = useOauthEnabled();

  var _useOauth = useOauth(),
      getIsAuthenticated = _useOauth.getIsAuthenticated;

  var _useSWR = useSWR.apply(void 0, _toConsumableArray(AuthFetchers.CheckSession({}))),
      data = _useSWR.data,
      refresh = _useSWR.mutate,
      isValidating = _useSWR.isValidating;

  React.useEffect(function () {
    if (oauthEnabled && !hasPendingAuthCheck) {
      setHasPendingAuthCheck(true);
      getIsAuthenticated().then(function (isAuthed) {
        setIsAuthenticated(!!isAuthed);
        setHasCompletedAuthCheck(true);
      });
    }
  }, [getIsAuthenticated, hasPendingAuthCheck, oauthEnabled]); // Oauth Flow

  if (oauthEnabled) {
    return {
      isLoggedIn: hasCompletedAuthCheck ? ok(!!isAuthenticated) : pending,
      refresh: refresh
    };
  } else {
    // Legacy Flow
    if (isValidating || !isDefined(data)) {
      return {
        isLoggedIn: pending,
        refresh: refresh
      };
    }

    var legacyLoggedIn = isDefined(data === null || data === void 0 ? void 0 : data.user) && (data === null || data === void 0 ? void 0 : data.isValid) === true;
    return {
      isLoggedIn: ok(legacyLoggedIn),
      refresh: refresh
    };
  }
};

export default useIsLoggedIn;